import { Locales } from '@ratehub/base-ui';


const PENALTY_PROVIDERS = [
    {
        id: 'bank-of-montreal',
        name_en: 'Bank of Montreal',
        name_fr: 'Banque de Montréal',
    },
    {
        id: 'cibc',
        name_en: 'CIBC',
        name_fr: 'Banque CIBC',
    },
    {
        id: 'desjardins',
        name_en: 'Desjardins',
        name_fr: 'Desjardins',
    },
    {
        id: 'first-national',
        name_en: 'First National',
        name_fr: 'Financière First National',
    },
    {
        id: 'hsbc',
        name_en: 'HSBC',
        name_fr: 'HSBC',
    },
    {
        id: 'mcap',
        name_en: 'MCAP',
        name_fr: 'MCAP',
    },
    {
        id: 'national-bank',
        name_en: 'National Bank',
        name_fr: 'Banque Nationale',
    },
    {
        id: 'rbc-royal-bank',
        name_en: 'RBC Royal Bank',
        name_fr: 'Banque Royale',
    },
    {
        id: 'scotiabank',
        name_en: 'Scotiabank',
        name_fr: 'Banque Scotia',
    },
    {
        id: 'simplii-financial',
        name_en: 'Simplii Financial',
        name_fr: 'Simplii Financiers',
    },
    {
        id: 'tangerine',
        name_en: 'Tangerine',
        name_fr: 'Tangerine',
    },
    {
        id: 'td-bank',
        name_en: 'TD Bank',
        name_fr: 'Banque TD',
    },
];

function createProviderOptions(intl) {
    return PENALTY_PROVIDERS.map(provider => (
        {
            label: intl.locale === Locales.ENGLISH
                ? provider.name_en
                : provider.name_fr,
            value: provider.id,
        }
    ));
}

export { createProviderOptions };
export default PENALTY_PROVIDERS;
